const initialState = {
    loading: null,
    token: '',
    userDetails: {},
    access: null,
};

const auth = (state = initialState, action) => {
    switch (action.type) {
        case 'AUTHSTART':
            return {
                ...state,
                isLoggedIn: false,
                loading: true,
            };
        case 'AUTHFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'AUTHSUCCESS':
            return {
                ...state,
                loading: null,
            };
        case 'SIGNUP':
            return {
                ...state,
                loading: null,
            };
        case 'LOGIN':
            return {
                ...state,
                isLoggedIn: true,
                loading: null,
                token: action.token,
                userDetails: action.details,
                access: action.access || null,
            };
        case 'SET_ACCESS':
            return {
                ...state,
                access: action.access || null,
            };
        case 'SET_AUTH_TOKEN':
            return {
                ...state,
                token: action.token || '',
            };
        case 'SET_USER_DETAILS':
            return {
                ...state,
                isLoggedIn: true,
                userDetails: {
                    ...state.userDetails,
                    ...action.details,
                },
                token: state.token || action.token || '',
            };
        case 'LOGOUT':
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default auth;